export enum Classes {
    ellipsisText = 'ellipsis-text',
}
